import { lazy } from "react"

const ConversionsIndex = lazy(() => import('../../views/conversions'))

const Conversions = [
  {
    
    path: '/conversions',
    element: <ConversionsIndex />
  }
]

export default Conversions